import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';
import ChartHistory_Environment from '../chart/ChartHistory_Environment.js';

import ModalLoad from '../modal/ModalLoad.js';
import ModalPopupMessage from '../modal/ModalPopupMessage.js';

function HistoricalDataEnvironment(props) {
    const [reportsite, setReportsite] = useState('-');

    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
    }

    const [chart_plot, setChart_plot] = useState({
        FileName: '',
        CSV_Data: [],
        XLabel: '',
        Sitename: '-',
        IRR1: [],
        IRR2: [],
        TempAmbient: [],
        Humidity: [],
        TempPV: [],
        TempTray: [],
        WindSpeed: [],
        WindDirect: [],
        WaterLevel: [],
    });

    async function api_query() {
        let dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD")

        setmodal_load({ enable: true, message: "Query historical environment." })
        await sleep(500)

        const formData = new FormData()
        formData.append('post_url', "/proxy/center/api/historical/sensor")
        formData.append('token', props.permitdata.token)

        formData.append('reportdate', dt)
        if (props.permitdata.view_mode === "local") {
            formData.append('reportsite', props.permitdata.sitecode)
        } else {
            formData.append('reportsite', reportsite)
        }

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/sensor", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.tabledata !== null) {
                        let arr1 = []
                        let arr2 = []
                        let arr3 = []
                        let arr4 = []
                        let arr5 = []
                        let arr6 = []
                        let arr7 = []
                        let arr8 = []
                        let arr9 = []
                        for (let i = 0; i < response.data.tabledata.length; i++) {
                            let dx = new Date(response.data.tabledata[i].timestamp)
                            arr1.push({ x: dx, y: response.data.tabledata[i]["irr1"] })
                            if (response.data.tabledata[i]["irr2"] !== undefined) {
                                arr2.push({ x: dx, y: response.data.tabledata[i]["irr2"] })
                            }
                            arr3.push({ x: dx, y: response.data.tabledata[i]["temp_ambient"] })
                            arr4.push({ x: dx, y: response.data.tabledata[i]["humidity"] })
                            arr5.push({ x: dx, y: response.data.tabledata[i]["temp_pv"] })
                            arr6.push({ x: dx, y: response.data.tabledata[i]["temp_raceway"] })
                            if (response.data.tabledata[i]["wind_speed"] !== undefined) {
                                arr7.push({ x: dx, y: response.data.tabledata[i]["wind_speed"] })
                                arr8.push({ x: dx, y: response.data.tabledata[i]["wind_direct"] })
                            }
                            if (response.data.tabledata[i]["water_level"] !== undefined) {
                                arr9.push({ x: dx, y: response.data.tabledata[i]["water_level"] })
                            }
                        }
                        setChart_plot({
                            ...chart_plot,
                            FileName: response.data.filename,
                            CSV_Data: response.data.tabledata,
                            Sitename: response.data.sitename,
                            IRR1: arr1,
                            IRR2: arr2,
                            TempAmbient: arr3,
                            Humidity: arr4,
                            TempPV: arr5,
                            TempTray: arr6,
                            WindSpeed: arr7,
                            WindDirect: arr8,
                            WaterLevel: arr9,
                            XLabel: response.data.xlabel,
                        })
                    }
                }
                else {
                    reset_chart()
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                reset_chart()
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        if (chart_plot.CSV_Data.length > 0) {
            let tableheader = ['Timestamp',
                'Irradiation #1 (W/m2)']

            if (chart_plot.CSV_Data[0]["irr2"] !== undefined) {
                tableheader.push('Irradiation #2 (W/m2)')
            }
            tableheader.push('Ambient Temperature (°C)')
            tableheader.push('Relative Humidity (%RH)')
            tableheader.push('Panel Temperature (°C)')
            tableheader.push('Tray Temperature (°C)')
            if (chart_plot.CSV_Data[0]["wind_speed"] !== undefined) {
                tableheader.push('Wind Speed (m/sec.)')
                tableheader.push('Wind Direction (Deg.)')
            }
            if (chart_plot.CSV_Data[0]["water_level"] !== undefined) {
                tableheader.push('Water Level (m.)')
            }

            const tableData = [];
            tableData.push(tableheader.join(","));
            for (const row of chart_plot.CSV_Data) {
                const rowData = [];
                if (row["timestamp"] !== null) {
                    if (row["timestamp"] !== "-") {
                        if (row["timestamp"] !== null) {
                            rowData.push(row["timestamp"].replaceAll(",", ""))
                        } else { rowData.push('') }

                        if (row["irr1"] !== null) {
                            rowData.push(row["irr1"])
                        } else { rowData.push('') }
                        if (chart_plot.CSV_Data[0]["irr2"] !== undefined) {
                            if (row["irr2"] !== null) {
                                rowData.push(row["irr2"])
                            } else { rowData.push('') }
                        }

                        if (row["temp_ambient"] !== null) {
                            rowData.push(row["temp_ambient"])
                        } else { rowData.push('') }
                        if (row["humidity"] !== null) {
                            rowData.push(row["humidity"])
                        } else { rowData.push('') }
                        if (row["temp_pv"] !== null) {
                            rowData.push(row["temp_pv"])
                        } else { rowData.push('') }
                        if (row["temp_raceway"] !== null) {
                            rowData.push(row["temp_raceway"])
                        } else { rowData.push('') }

                        if (chart_plot.CSV_Data[0]["wind_speed"] !== undefined) {
                            if (row["wind_speed"] !== null) {
                                rowData.push(row["wind_speed"])
                            } else { rowData.push('') }
                            if (row["wind_direct"] !== null) {
                                rowData.push(row["wind_direct"])
                            } else { rowData.push('') }
                        }

                        if (chart_plot.CSV_Data[0]["water_level"] !== undefined) {
                            if (row["water_level"] !== null) {
                                rowData.push(row["water_level"])
                            } else { rowData.push('') }
                        }
                        tableData.push(rowData.join(","));
                    }
                }
            }

            let data = tableData.join("\n");
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
            var fnamey = 'EnvironmentSensor_' + chart_plot.FileName + '.csv'
            a.setAttribute("download", fnamey);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to be export",
                enable: true
            })
        }
    }

    function reset_chart() {
        setChart_plot({
            FileName: '',
            CSV_Data: [],
            XLabel: '',
            Sitename: '-',
            IRR1: [],
            IRR2: [],
            TempAmbient: [],
            Humidity: [],
            TempPV: [],
            TempTray: [],
            WindSpeed: [],
            WindDirect: [],
            WaterLevel: [],
        })
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Environment</h4>
                                    <p className="mb-0">Query your environment sensor</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block " style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Environment Chart</h5>
                                    <div className='query-info-table mt-0'>
                                        <div className='query-info-row'>
                                            <div className='query-info-cell info-name'>Site Name</div>
                                            <div className='query-info-cell'>{chart_plot.Sitename}</div>
                                        </div>
                                    </div>
                                    <ChartHistory_Environment
                                        irr1={chart_plot.IRR1}
                                        irr2={chart_plot.IRR2}
                                        temp_ambient={chart_plot.TempAmbient}
                                        humidity={chart_plot.Humidity}
                                        temp_pv={chart_plot.TempPV}
                                        temp_raceway={chart_plot.TempTray}
                                        wind_speed={chart_plot.WindSpeed}
                                        wind_direct={chart_plot.WindDirect}
                                        water_level={chart_plot.WaterLevel}
                                        xlabel={chart_plot.XLabel}
                                    ></ChartHistory_Environment>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataEnvironment